import { colors as tokens } from "@rubi/ui";

export const colors = {
  ERROR_TEXT_RED: tokens.error.main,
  // Despite the name, this is the brand primary, not a text colour. Currently
  // unused; kept so the constant is at least correct if it is picked up again.
  MUI_TEXT_PRIMARY: tokens.brand[500],
  // Portal-chrome indigo — no slot in theme.config.json, so it lives in the
  // shared legacy quarantine rather than as a literal here.
  MUI_TEXT_SECONDARY: tokens.legacy.indigo,
  /** Dark surface for AppBar controls and their popovers/menus. Not the sidebar's darker #1A1B2B. */
  APPBAR_CONTROL_BG: "#23243a",
};
